import { render } from "./LeftArrowIcon.vue?vue&type=template&id=32dceeb5"
const script = {}

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__